import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

export const FooterItem = ({ title, url }) => (
  <Container>
    <Nav to={url}>{title}</Nav>
  </Container>
);

const Container = styled.li`
  padding: 1.5em 1em;
  display: block;
`;
